import {WhatIfScenarioConfig, WhatIfScenarioInputValues} from "../../ps-types";
import {ValueType} from "../../ps-models/line-items";
import {assocPath} from "ramda";
import {Grid, Input} from "semantic-ui-react";
import {convertToNumberStringOrBoolean, entries} from "../../ps-models";
import React, {useEffect, useState} from "react";
import { TableLocatorInput } from "./TableLocatorInput";
// import { TableLocatorInput } from "./TableLocatorInput";

export function LocatorsMapInput({mappingConfig, inputValues, onValuesUpdated}: {
  mappingConfig: WhatIfScenarioConfig['mappingConfig'],
  inputValues: WhatIfScenarioInputValues,
  onValuesUpdated: (values: WhatIfScenarioInputValues) => void
}) {

  const [values, setValues] = useState<Record<string, string[][]>>({});

  useEffect(() => {
    entries(inputValues).forEach(([key, value]) => {
      let mappingConfigLocatorType = mappingConfig[key]?.locator?.type;
      if(mappingConfigLocatorType === "table") {
        values[key] = value.value.map((r)=>r?.map((v)=>v?.toString()));
      } else {
        values[key] = [[value?.value?.[0]?.[0]?.toString()]];
      }
    });
    setValues(values);
  }, [inputValues]);

  const handleLocatorChange = (valueKey: string, value: ValueType) => {

    //Update the corresponding value
    let valuesUpdated = assocPath([valueKey],
      ({value: [[ convertToNumberStringOrBoolean(value)]], valueKey: valueKey}),
      inputValues
    );

    onValuesUpdated(valuesUpdated);
  }

  const handleTableLocatorChange = (valueKey: string, value: ValueType[][]) => {

    //Update the corresponding value
    let valuesUpdated = assocPath([valueKey],
      ({value: value.map((r)=>r.map((c)=>convertToNumberStringOrBoolean(c))), valueKey: valueKey}),
      inputValues
    );

    onValuesUpdated(valuesUpdated);
  }

  return <>
    <Grid>
      {
        Object.values(mappingConfig).map((conf) => {
          let key = conf.valueKey;
          return <Grid.Row columns={2}>
            <Grid.Column>
              <strong>{conf.label}</strong>
            </Grid.Column>
            <Grid.Column>
              {conf.locator.type === "table" && <>
                <TableLocatorInput
                  data={values[key]}
                  onChange={(newData: string[][]) => {
                    setValues({...values, [key]: newData})
                  }}
                  onTableBlur={(data) => {
                    handleTableLocatorChange(key, data)
                  }}
                  />
              </>}
              {(conf.locator.type === "cell" || conf.locator.type === "parameter") && <Input
                      value={values?.[key]?.[0]?.[0] || ""}
                      onChange={(e:any) => {
                        setValues({...values, [key]: [[e.target.value]]})
                      }}
                     onBlur={(e:any) => {
                       handleLocatorChange(key, e.target.value)
                     }}
              />}

            </Grid.Column>
          </Grid.Row>
        })
      }
    </Grid>
  </>
}